export const yesNoOptions = ['Yes', 'No'];

export const jids = [
  'Barbados',
  'California',
  'Colorado',
  'Connecticut',
  'Florida (Cape Coral)',
  'Florida (Jacksonville)',
  'Florida (Miami)',
  'Florida (Orlando)',
  'Florida (Pensacola)',
  'Florida (Tallahassee)',
  'Florida (Tampa)',
  'Georgia',
  'Indiana',
  'Kentucky',
  'Massachusetts',
  'Michigan (Wixom)',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Nebraska',
  'New Jersey',
  'New York (Bronx)',
  'New York (Islandia)',
  'New York (Latham)',
  'New York (Rochester)',
  'New York (Saugerties)',
  'North Carolina',
  'Oregon',
  'Rhode Island',
  'RRF',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas (Abilene)',
  'Texas (Austin)',
  'Texas (Lubbock)',
  'Texas (El Paso)',
  'Texas (Houston)',
  'Texas (Irving)',
  'Texas (Mcallen)',
  'Texas (San Antonio)',
  'Texas (Tyler)',
  'Usvi',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
];
